var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgE(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_47_9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FAC95D",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.19048,
    y: 0.190476,
    width: 31.619,
    height: 31.619,
    rx: 15.8095,
    stroke: "black",
    strokeWidth: 0.380952,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_47_9",
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 7.5,
    width: 12,
    height: 19,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 12,
    y: 7.5,
    width: 12,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4146 25.5H13.3281V7.98646H23.4146V11.0292H17.0417V14.8745H22.9714V17.9172H17.0417V22.4333H23.4146V25.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.4146 25.5H13.3281V7.98646H23.4146V11.0292H17.0417V14.8745H22.9714V17.9172H17.0417V22.4333H23.4146V25.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4146 25.5V25.881H23.7955V25.5H23.4146ZM13.3281 25.5H12.9472V25.881H13.3281V25.5ZM13.3281 7.98646V7.6055H12.9472V7.98646H13.3281ZM23.4146 7.98646H23.7955V7.6055H23.4146V7.98646ZM23.4146 11.0292V11.4101H23.7955V11.0292H23.4146ZM17.0417 11.0292V10.6482H16.6607V11.0292H17.0417ZM17.0417 14.8745H16.6607V15.2554H17.0417V14.8745ZM22.9714 14.8745H23.3523V14.4935H22.9714V14.8745ZM22.9714 17.9172V18.2981H23.3523V17.9172H22.9714ZM17.0417 17.9172V17.5362H16.6607V17.9172H17.0417ZM17.0417 22.4333H16.6607V22.8143H17.0417V22.4333ZM23.4146 22.4333H23.7955V22.0524H23.4146V22.4333ZM23.4146 25.119H13.3281V25.881H23.4146V25.119ZM13.7091 25.5V7.98646H12.9472V25.5H13.7091ZM13.3281 8.36741H23.4146V7.6055H13.3281V8.36741ZM23.0336 7.98646V11.0292H23.7955V7.98646H23.0336ZM23.4146 10.6482H17.0417V11.4101H23.4146V10.6482ZM16.6607 11.0292V14.8745H17.4226V11.0292H16.6607ZM17.0417 15.2554H22.9714V14.4935H17.0417V15.2554ZM22.5904 14.8745V17.9172H23.3523V14.8745H22.5904ZM22.9714 17.5362H17.0417V18.2981H22.9714V17.5362ZM16.6607 17.9172V22.4333H17.4226V17.9172H16.6607ZM17.0417 22.8143H23.4146V22.0524H17.0417V22.8143ZM23.0336 22.4333V25.5H23.7955V22.4333H23.0336Z",
    fill: "black",
    mask: "url(#path-3-outside-1_47_9)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_47_9",
    x: 0.47619,
    y: 0,
    width: 35.0476,
    height: 35.0476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.52381
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.761905
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_47_9"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_47_9",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE);
export default __webpack_public_path__ + "static/media/E.b586b20486fc403c6bbb7c7541cf3d1a.svg";
export { ForwardRef as ReactComponent };